'use client';

import { ReactNode, useMemo, useState } from 'react';
import { TransitioningContext } from './TransitioningContext';

interface TransitioningProviderProps {
  children?: ReactNode;
}

export default function TransitioningProvider({
  children,
}: TransitioningProviderProps) {
  const [transitioning, setTransitioning] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const transitioningCtx = useMemo(
    () => ({
      transitioning,
      setTransitioning,
      disabled,
      setDisabled,
    }),
    [transitioning, disabled],
  );

  return (
    <TransitioningContext.Provider value={transitioningCtx}>
      {children}
    </TransitioningContext.Provider>
  );
}
